import { enqueueSnackbar } from "notistack";
import { globalExportService } from "./globalApiServices";

export const handleExport = ({ URL, name, setExportLoader,query }) => {
    setExportLoader(true);
    globalExportService(URL, { responseType: "blob",...query })
        .then((response) => {
            const blobType = response.data.type || response.headers['content-type'];

            if (blobType === "application/json") {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const errorData = JSON.parse(e.target.result);
                    enqueueSnackbar(errorData.message || "Export failed", {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                    });
                };
                reader.readAsText(response.data);
                setExportLoader(false);
                return;
            }

            // const blob = new Blob([response.data], { type: "application/pdf" }); //previous code
            const blob = new Blob([response.data], {type: blobType}) //new changes
            const blobUrl = window.URL.createObjectURL(blob);

            const fileName = `${name}`;  //new changes
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

            // window.open(blobUrl, "_blank", "noopener,noreferrer"); //previous code

            enqueueSnackbar("File has been exported successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
        })
        .catch((error) => {
            enqueueSnackbar(
                error.response?.data?.message || error?.message || "Failed to open file",
                { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }
            );
        })
        .finally(() => setExportLoader(false));
};